
import FormInput from '@/components/FormInput/FormInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import ViewModel from '@/models/ViewModel'

import {
  Component, Prop, Ref, Vue, Watch,
} from 'vue-property-decorator'
import DistributionGoal from '@/models/DistributionGoal'
import { percentageMask } from '@/models/interface/Masks'
import { getModule } from 'vuex-module-decorators'
import InventoryModule from '@/store/model/InventoryModule'
import Inventory from '@/models/Inventory'
import WebMessage from '@/models/WebMessage'

@Component({
  components: {
    FormInput,
    IconAction,
    SelectPicker,
  },
})
export default class DistributionGoalGroup extends ViewModel {
  public must_filter: boolean = false

  @Ref() public observer: any

  @Prop({ default: true })
  public local_label!: boolean

  @Prop()
  public value!: any

  @Prop()
  public selected_adunits!: any

  @Prop()
  public exclude_adunits!: any

  @Prop({ default: '' })
  public adserver!: string

  @Prop({ default: false })
  public disabled!: any

  @Prop({ default: false })
  public hideButton!: boolean

  @Prop({ default: false })
  customInventory!: boolean

  @Prop()
  selectedMediaPackage!: any

  @Prop({ default: false })
  public useType!: boolean

  @Prop({ default: false })
  public debug!: boolean

  @Prop()
  public settings!: any

  @Prop()
  public maxGoalLength!: number

  @Prop({ default: true })
  public enableFilter!: boolean

  @Prop()
  public distributionGoalMetrics!: any

  @Prop()
  public bookedImpressions!: any

  public loading: boolean = true

  public inventories: any = []

  public inventoryModule: InventoryModule = getModule(InventoryModule)

  public can_load: boolean = false

  public local_value: any = []

  public hideSelect: boolean = false

  public mode_options = [
    {
      value: 'percentage',
      name: 'Percentage',
    },
  ]

  public type_options = [
    {
      value: 'fep',
      name: 'FEP',
    },
    {
      value: 'live',
      name: 'Live',
    },
    {
      value: 'default',
      name: 'Default',
    },
  ]

  public adunit_options: any = []

  public value_limit_reached: boolean = false

  @Watch('selected_adunits')
  public onValueChange(val: any) {
    if (val && this.can_load) {
      setTimeout(() => {
        this.getAdunits()
      }, 500)
    }
  }

  @Watch('local_value')
  public onLocalValueChange(val: any) {
    if (val && this.can_load) {
      this.$emit('input', val)
    }
  }

  @Watch('exclude_adunits')
  public onExcludeAdunitsChange(val: any) {
    if (val && val.length) {
      this.adunit_options = this.adunit_options.filter(
        (adunit: any) => !this.exclude_adunits.includes(adunit.value),
      )
    }
  }

  @Watch('totalOfAllValues')
  public onTotalOfAllValuesChange(val: any) {
    if (val > 100) {
      this.value_limit_reached = true
      this.toggleSaveBtn(true)
    } else {
      this.value_limit_reached = false
      this.toggleSaveBtn(false)
    }
  }

  public get unused_adunits() {
    return this.adunit_options.filter(
      (option: any) =>
        !this.local_value.some((unit: any) => unit.target_adunits.includes(option.value)),
    )
  }

  public get totalOfAllValues() {
    return this.local_value.reduce((acc: any, goal: any) => acc + goal.value, 0)
  }

  public get masks() {
    return {
      percentage: percentageMask,
    }
  }

  public get duplicateTypes() {
    return this.local_value.some((group: any, gIndx: number) =>
      this.local_value.some(
        (other: any, oIndx: number) => gIndx !== oIndx && group.type === other.type,
      ))
  }

  public get canAddMoreGoals() {
    if (this.maxGoalLength !== undefined) {
      return this.local_value.length < this.maxGoalLength
    }
    return true
  }

  @Watch('duplicateTypes')
  public onDuplicateTypesChange(val: any) {
    this.$emit('duplicate-types', !val)
  }

  public mapWithType(val: any[]) {
    return val.map((v: any) => {
      if (!v.type || !v.type.length) {
        v.type = 'default'
      }
      return v
    })
  }

  public syncLocalValue() {
    if (this.value) {
      this.local_value = this.mapWithType(this.value)
    }
  }

  public mounted() {
    Inventory.module
      .getTree(this.adserver)
      .then((res: any) => {
        this.inventories = this.inventoryModule.all_data
        this.local_value = this.value ?? []
        this.getAdunits()
        this.can_load = true
        this.loading = false
        this.local_value = this.mapWithType(this.local_value)
      })
      .catch((err: any) => {
        this.can_load = true

        this.loading = false
      })
  }

  public removeUsedOptions() {
    this.getAdunits()

    this.adunit_options = this.unused_adunits

    Vue.set(this, 'adunit_options', this.unused_adunits)

    this.checkForSelectionWithinTypes()
  }

  public addGoal() {
    let types_in_use = this.local_value.map((group: any) => group.type)

    let goal = new DistributionGoal()

    if (types_in_use.includes('default')) {
      goal.type = 'fep'
    }
    if (types_in_use.includes('fep')) {
      goal.type = 'live'
    }

    this.local_value.push(goal)
    // this.adunit_options = this.unused_adunits
    this.removeUsedOptions()
  }

  public removeGoal(index: number) {
    this.local_value.splice(index, 1)
  }

  public getAdunits(selected_adunits: any = null) {
    let opts: any = []

    let selections = this.inventories.filter(i => {
      if (selected_adunits) {
        return selected_adunits.includes(i.id)
      }
      return this.selected_adunits.includes(i.id)
    })

    selections.forEach((selected: any) => {
      opts.push({
        value: selected.id,
        name: selected.name,
        parent_id: selected.parent_id,
        hierarchy_ids: selected.hierarchy_ids,
        product: selected.product,
        publisher: selected.publisher,
      })
      if (selected.hierarchy_ids && selected.hierarchy_ids.length > 0) {
        let found = this.inventories.filter((i: any) => selected.hierarchy_ids.includes(i.id))

        found.forEach((fd: any) => {
          opts.push({
            value: fd.id,
            name: fd.name,
            parent_id: fd.parent_id,
            hierarchy_ids: fd.hierarchy_ids,
            product: fd.product,
            publisher: fd.publisher,
          })
        })

        found.forEach((element: any) => {
          let by_parent = this.inventories.filter((i: any) => i.parent_id === element.id)
          by_parent.forEach((bp: any) => {
            opts.push({
              value: bp.id,
              name: bp.name,
              parent_id: bp.parent_id,
              hierarchy_ids: bp.hierarchy_ids,
              product: bp.product,
              publisher: bp.publisher,
            })
          })
        })
      } else {
        let by_parent = this.inventories.filter(
          (i: any) => i.parent_id === selected.id || i.hierarchy_ids.includes(selected.id),
        )

        by_parent.forEach((bp: any) => {
          opts.push({
            value: bp.id,
            name: bp.name,
            parent_id: bp.parent_id,
            hierarchy_ids: bp.hierarchy_ids,
            product: bp.product,
            publisher: bp.publisher,
          })
        })
      }
    })

    this.adunit_options = opts.filter(
      (el: any, indx: number) => opts.findIndex((obj: any) => obj.value === el.value) === indx,
    )

    this.adunit_options = this.adunit_options.map((adunit: any) => ({
      value: adunit.value,
      name: this.formatName(adunit),
      parent_id: adunit.parent_id,
      hierarchy_ids: adunit.hierarchy_ids,
      product: adunit.product,
      publisher: adunit.publisher,
    }))

    if (this.debug) {
      this.$nextTick(() => {
        this.checkHomeTags()
      })
    }

    this.$nextTick(() => {
      if (this.$route.name === 'MediaPackages') {
        this.local_value.forEach((group: any, gIndx: number) => {
          // @ts-ignore
          if (this.$refs[`group-type-${gIndx}`] && this.$refs[`group-type-${gIndx}`][0]) {
            // @ts-ignore
            this.$refs[`group-type-${gIndx}`][0].$refs.validationProvider.validate()
          }
        })
        this.checkForSelectionWithinTypes(0)
      }
    })
  }

  /**
   * This will work for two levels of childs
   */
  public formatName(target: DistributionGoal) {
    let temp_name: string = ''

    let adunit: Inventory = this.inventories.find(
      (inventory: Inventory) => inventory.id === target.value,
    )

    temp_name = adunit.name

    if (adunit.parent_id) {
      let found = this.inventories.find((inventory: Inventory) => inventory.id === adunit.parent_id)

      if (found.parent_id) {
        let found2 = this.inventories.find(
          (inventory: Inventory) => inventory.id === found.parent_id,
        )
        temp_name = `${found2.name} > ${found.name} > ${adunit.name}`
      } else {
        temp_name = `${found.name} > ${adunit.name}`
      }
    }
    if (adunit.product && this.debug) {
      temp_name = `(${adunit.product}) ${temp_name}`
    }
    return temp_name
  }

  public toggleSaveBtn(disable: boolean = false) {
    let btn = document.getElementById('navigate-next')

    if (disable) {
      btn?.setAttribute('disabled', 'disabled')
    } else {
      btn?.removeAttribute('disabled')
    }
  }

  public confirmIfNeeded(exe: any) {
    if (!this.customInventory && this.selectedMediaPackage && this.selectedMediaPackage.length) {
      // alert user
      WebMessage.doubleConfirm(
        'Are you sure you want to modify the Media Package original Distribution Goal?',
        'Modify Original Goals',
        'Yes, Modify Distribution Goals',
      ).then((res: any) => {
        if (res) {
          exe()
          this.$emit('update:customInventory', true)
        }
      })
    } else {
      exe()
    }
  }

  public refreshDistribution() {
    this.hideSelect = true

    const val = JSON.parse(JSON.stringify(this.local_value))

    let update: any = {}
    let remove: any = []
    let update_percentage: any = {}

    val.forEach((goal: DistributionGoal, index: number) => {
      let group_type = goal.type === 'default' ? 'home' : 'ssl'

      let target_adunits = goal.target_adunits

      let adunits = this.inventories.filter(
        (adunit: any) =>
          target_adunits.includes(adunit.id) && adunit.product === this.settings.product_type,
      )

      let options = adunits.filter((adunit: any) =>
        this.selected_adunits.some(
          (selected: any) => adunit.hierarchy_ids.includes(selected) || adunit.id === selected,
        ))

      if (!options.length || group_type !== this.settings.product_type) {
        remove.push(goal.id)
      }

      update[index] = options.map((option: any) => option.id)
      update_percentage[index] = this.shareImpressions(goal.type)
    })

    // update by index
    Object.keys(update).map((key: any) => {
      Vue.set(this.local_value[key], 'target_adunits', update[key])
      Vue.set(this.local_value[key], 'value', update_percentage[key])
      return key
    })

    this.hideSelect = false

    remove.forEach((id: string) => {
      this.local_value = this.local_value.filter((group: any) => group.id !== id)
    })
  }

  public checkHomeTags() {
    const tags = document.querySelectorAll('.multiselect__tag > span:first-child')
    tags.forEach(tag => {
      if (tag.textContent && tag.textContent.startsWith('(home)')) {
        (tag.parentNode as HTMLElement).classList.add('home-tag')
      }
    })
  }

  public shareImpressions(key: string) {
    // 70 live, 20 fep, 10 home
    // ___________________________
    // live = (live + fep = 90)------> 70 live, / 90 = x
    // fep = 100 - x
    // home = 10
    // ___________________________
    // the sum of fep and live must be 100%

    let origin_live = this.settings.target_products[0].distribution_values.live // 70
    let origin_fep = this.settings.target_products[0].distribution_values.fep // 20
    let origin_home = this.settings.target_products[0].distribution_values.home

    let x = (origin_live / (origin_live + origin_fep)) * 100
    let y = 100 - x

    let res: any = {
      live: Math.round(x),
      fep: Math.round(y),
      default: 100,
    }

    return res[key]
  }

  public filterBy(opts: any[], type: string) {
    if (this.$route.name !== 'MediaPackages' || !this.enableFilter) {
      return opts
    }
    return opts.filter(opt => {
      let ref = type === 'default' ? 'home' : 'ssl'
      return opt.product === ref
    })
  }

  public addTypeErrors(index: number, msg: any = ['Invalid target type']) {
    // @ts-ignore
    this.$refs[`target-${index}`][0].$refs.validationProvider.setErrors(msg)
  }

  public checkForSelectionWithinTypes(tmo: number = 500) {
    if (this.$route.name === 'MediaPackages' && this.enableFilter) {
      setTimeout(() => {
        let wrong_selection: any = {}
        this.local_value.forEach((item: any, index: number) => {
          let selected = this.inventories.filter((option: any) =>
            item.target_adunits.includes(option.id))

          let type = item.type === 'default' ? 'home' : 'ssl'

          let wrong_selections = selected.filter((option: any) => option.product !== type)

          wrong_selection[index] = wrong_selections
        })

        Object.keys(wrong_selection).forEach((key: any) => {
          if (wrong_selection[key].length) {
            this.addTypeErrors(key)
          }
        })
      }, tmo)
    }
  }

  public get distributionGoalMetricByKey() {
    const map = new Map()
    this.distributionGoalMetrics.forEach((item: any) => {
      map.set(item._id, item)
    })

    return map
  }

  public getGoalBasedOnShare(value: number) {
    return (value / 100) * this.bookedImpressions
  }

  public getPercentageOfGoalValue(impressions_made: number, goal_impressions: number) {
    if (!goal_impressions || !impressions_made) {
      return 0
    }
    return (impressions_made / goal_impressions) * 100
  }

  public hasMetrics(id: string) {
    return (
      this.distributionGoalMetrics
      && this.distributionGoalMetricByKey.has(id)
      && this.distributionGoalMetricByKey.get(id).hasOwnProperty('metrics')
      && this.distributionGoalMetricByKey.get(id).metrics.hasOwnProperty('impressions')
      && this.distributionGoalMetricByKey.get(id).hasOwnProperty('value')
    )
  }
}
